import Navbar from "../components/Navbar/Navbar";
import "./layout.css";

const OnboardLayout = (props) => {
  return (
    <>
      <Navbar isFixed isShadowActive isTransparent />
      <div className="onboard-layout" style={props.styles}>
        {props.children}
      </div>
    </>
  );
};

export default OnboardLayout;
